import { render, staticRenderFns } from "./SalePersonComponent.vue?vue&type=template&id=24b09b2e"
import script from "./SalePersonComponent.vue?vue&type=script&lang=js"
export * from "./SalePersonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports